<ng-container>
    <div
        class="relative flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between py-8 px-6 md:px-8 border-b ">
        <div class="text-4xl font-extrabold tracking-tight">
            Photos
        </div>

        <div class="flex shrink-0 items-center mt-6 sm:mt-0 sm:ml-4">
            <button mat-flat-button [color]="'primary'" (click)="openPhotoModal()">
                <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                <span class="ml-2 mr-1">Ajouter</span>
            </button>
            <button class="bg-accent-200 ml-4" [disabled]="downloading" mat-button *ngIf="selectedPhotos.length > 0"
                    (click)="downloadSelected()">
                <mat-icon
                    class="icon-size-5 text-current"
                    [svgIcon]="'heroicons_solid:download'"></mat-icon>
                Télécharger
            </button>
        </div>
    </div>
    <div class="p-4" *ngIf="isLoaded">
        <div *ngIf="photos.length === 0">
            <h3 class="text-gray-500 font-bold text-xl text-center">
                Aucune photo disponible
            </h3>
        </div>

        <div *ngIf="photos.length !== 0">
            <div class="flex flex-col flex-auto min-w-0" *ngFor="let photoStack of formatedPhotos;">
                <div class="sm:inset-0 flex flex-col flex-auto min-w-0 sm:overflow-hidden bg-card">
                    <div class="relative pt-8 px-6 md:px-8">
                        <p class="text-2xl font-extrabold tracking-tight"><input type="checkbox"
                                                                                 (change)="toggleAllDate($event, photoStack.date)"/>
                            Date: {{ photoStack.date }}</p>
                    </div>
                    <div class="grid-container">
                        <div class="photos-dossiers-grid">
                            <div class="photo-dossier-card" *ngFor="let photo of photoStack.photos">
                                <div
                                    class="relative block bg-white rounded-lg border border-gray-200 shadow-md overflow-hidden max-h-[400px] duration-200">
                                    <span class="absolute top-3 right-3">
                                        <input type="checkbox" class="text-lg" [checked]="selectedPhotos.includes(photo.id)"
                                               (change)="togglePhoto($event, photo)"/>
                                    </span>
                                    <img
                                        *ngIf="!photo.path.includes('.mp4')"
                                         [src]="STORAGE_URL + photo.path"
                                         [alt]="photo.name"
                                        class="w-full object-contain max-h-[200px] w-[375px]"
                                    />
                                    <video controls *ngIf="photo.path.includes('.mp4')"
                                           class="w-full object-contain h-[200px] w-[375px]">
                                        <source [src]="STORAGE_URL + photo.path">
                                    </video>
                                    <div class="p-6 flex">
                                        {{ getNomPiece(photo.piece_id) }}
                                        <div class="flex-grow text-right">
                                            <button
                                                class="w-6 h-6 min-h-6"
                                                mat-icon-button
                                                (click)="openSingle(photo)"
                                                matTooltip='Aperçu'>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="icon-size-4">
                                                    <path fillRule="evenodd" d="M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Z" clipRule="evenodd" />
                                                </svg>
                                            </button>
                                            <button
                                                *ngIf="isAdmin"
                                                class="w-6 h-6 min-h-6 text-warn ml-2"
                                                mat-icon-button
                                                (click)="delete(photo)"
                                                matTooltip='Supprimer'>
                                                <mat-icon
                                                    class="icon-size-4 text-current"
                                                    [svgIcon]="'heroicons_solid:trash'"></mat-icon>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


</ng-container>

